import { render, staticRenderFns } from "./NewHotelMember.vue?vue&type=template&id=3dfa2130&scoped=true"
import script from "./NewHotelMember.vue?vue&type=script&lang=js"
export * from "./NewHotelMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa2130",
  null
  
)

export default component.exports